import { BaseModel } from "model/base.model";

export interface  PayeeEnterprise extends BaseModel {
    code?: string;
    name?: string;
};

export const defaultPayeeEnterprise: Readonly<PayeeEnterprise> = {};